<template>
    <card>
        <h3 class="p-3 d-flex flex-column flex-lg-row align-items-center justify-content-between">
            <b> Sistema de Gestión : Mantenimientos </b>
        </h3>
        <hr />
        <div class="row justify-content-center text-center pt-4 pb-2 bg-dark rounded-pill m-2">
            <div class="row col-12 offset-sm-0 flex-wrap justify-content-center">
                <div class="p-2 col-12 col-sm-3 col-lg-2">
                    <button class="btn-evaluacion  btn-circle btn-secondary"
                        :class="tipoMantenimiento == 1 ? 'active' : ''" :disabled="loading" @click="cambiarVista(1)">
                        <span class="h3"><i class="fa-solid fa-bell"></i></span>
                    </button>
                    <p class="pt-3 h4">Mantenimiento Preventivo</p>
                </div>
                <div class="p-2 col-12 col-sm-3 col-lg-2">
                    <button class="btn-evaluacion btn-circle btn-secondary"
                        :class="tipoMantenimiento == 2 ? 'active' : ''" :disabled="loading" @click="cambiarVista(2)">
                        <span class="h3"><i class="fa-solid fa-screwdriver-wrench"></i></span>
                    </button>
                    <p class="pt-3 h4">Mantenimiento Correctivo</p>
                </div>
                <div class="p-2 col-12 col-sm-3 col-lg-2">
                    <button class="btn-evaluacion btn-circle btn-secondary"
                        :class="tipoMantenimiento == 3 ? 'active' : ''" :disabled="loading" @click="cambiarVista(3)">
                        <span class="h3"><i class="fa-solid fa-list-check"></i></span>
                    </button>
                    <p class="pt-3 h4">Alistamiento</p>
                </div>
                <div class="p-2 col-12 col-sm-3 col-lg-2">
                    <button class="btn-evaluacion btn-circle btn-secondary"
                        :class="tipoMantenimiento == 4 ? 'active' : ''" :disabled="loading" @click="cambiarVista(4)">
                        <span class="h3"><i class="fa-solid fa-thumbs-up"></i></span>
                    </button>
                    <p class="pt-3 h4">Autorizaciones</p>
                </div>
            </div>
        </div>
        <div class=" m-2 p-3 mt-3 rounded-pill">
            <div v-if="loading" class="text-center py-5">
                <div class="loading-container">
                    <div class="emoji-container mb-3">
                        <span class="emoji animate-bounce h2" role="img" aria-label="Car">🚗</span>
                        <span class="emoji animate-pulse h2" role="img" aria-label="Hourglass">⏳</span>
                        <span class="emoji animate-bounce h2" role="img" aria-label="Thinking">🤔</span>
                    </div>
                    <span class="font-weight-bold text-primary h2">Obteniendo información...</span>
                    <p class="loading-message text-muted">
                        Espere un momento mientras preparamos los datos.
                    </p>
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Cargando...</span>
                    </div>
                </div>
            </div>
            <div v-if="!loading">
                <div class="d-flex flex-row flex-wrap col-12 align-items-center justify-content-between">
                    <div class="col-12 col-sm-12 d-flex flex-wrap flex-sm-nowrap" :class="DiferenteADespacho()">
                        <div class="col-12 bg-dark bg-dark-hover p-3 rounded">
                            <h5>
                                {{ tituloOpcion }}
                            </h5>
                            <p class="text-white-50">{{ descripcionOpcion }}</p>
                        </div>
                    </div>
                </div>
                <div v-if="tipoMantenimiento == 1">
                    <DataTableButtonsObjeto :items="itemsListar" :headers="headersDespacho" :keys="keyDespacho"
                        :actions1="confirmarMantenimiento" button1="fa-solid fa-plus" titleButton1="Agregar información"
                        :actions2="detallesMantenimiento" button2="fa-solid fa-circle-info"
                        titleButton2="Detalles del mantenimiento" tableId="datatable_Despacho"
                        class="mt-2 w-100 h-100" />
                </div>
                <div v-if="tipoMantenimiento == 2">
                    <DataTableButtonsObjeto :items="itemsListar" :headers="headersDespacho" :keys="keyDespacho"
                        :actions1="confirmarMantenimiento" button1="fa-solid fa-plus" titleButton1="Agregar información"
                        :actions2="detallesMantenimiento" button2="fa-solid fa-circle-info"
                        titleButton2="Detalles del mantenimiento" tableId="datatable_Despacho"
                        class="mt-2 w-100 h-100" />
                </div>
                <div v-if="tipoMantenimiento == 3">
                    <DataTableButtonsObjeto :items="itemsListar" :headers="headersDespacho" :keys="keyDespacho"
                        :actions1="confirmarMantenimiento" button1="fa-solid fa-plus" titleButton1="Agregar información"
                        :actions2="detallesMantenimiento" button2="fa-solid fa-circle-info"
                        titleButton2="Detalles del mantenimiento" tableId="datatable_Despacho"
                        class="mt-2 w-100 h-100" />
                </div>
                <div v-if="tipoMantenimiento == 4">
                    <DataTableButtonsObjeto :items="itemsListar" :headers="headersDespacho" :keys="keyDespacho"
                        :actions1="confirmarMantenimiento" button1="fa-solid fa-plus" titleButton1="Agregar información"
                        :actions2="detallesMantenimiento" button2="fa-solid fa-circle-info"
                        titleButton2="Detalles del mantenimiento" tableId="datatable_Despacho"
                        class="mt-2 w-100 h-100" />
                </div>
            </div>
        </div>


        <!-- Modal para añadir nuevos mantenimientos -->
        <b-modal ref="Mantenimientos" size="xl"  hide-footer header-class="bg-dark border-none pb-4" content-class="bg-dark rounded ">
            <MantenimientoPreventivo v-if="tipoMantenimiento == 1" @consultarMantenimientos="obtenerValores(1)"
                :infoComplementaria="infoComplementaria" :idMantenimiento="idMantenimiento" />
            <MantenimientoCorrectivo v-if="tipoMantenimiento == 2" @consultarMantenimientos="obtenerValores(2)"
                :infoComplementaria="infoComplementaria" :idMantenimiento="idMantenimiento" />
            <Alistamiento v-if="tipoMantenimiento == 3" @consultarMantenimientos="obtenerValores(3)"
                :infoComplementaria="infoComplementaria" :idMantenimiento="idMantenimiento"></Alistamiento>
            <Autorizaciones v-if="tipoMantenimiento == 4" @consultarMantenimientos="obtenerValores(4)"
                :infoComplementaria="infoComplementaria" :idMantenimiento="idMantenimiento"></Autorizaciones>
        </b-modal>

        <!-- Modal para información adicional de los mantenimientos -->
        <b-modal ref="DetalleMantenimientos" size="xl"  hide-footer header-class="bg-dark border-none pb-4" content-class="bg-dark rounded ">
            <detallesMantenimientos v-if="tipoMantenimiento == 1 || tipoMantenimiento == 2" :datos="detallesMantenimientos" />
            <detallesMantenimientosAlistamiento v-if="tipoMantenimiento == 3" :datos="detallesMantenimientos" />
            <detallesMantenimientosAutorizaciones v-if="tipoMantenimiento == 4" :datos="detallesMantenimientos" />
            <!-- <formularioGeneral :idDespacho="idDespacho"></formularioGeneral> -->
        </b-modal>

    </card>
</template>

<script>
import DataTableButtonsObjeto from "../../../../components/Datatable/DatatableButtonsObjeto.vue";
import Alistamiento from "./Formularios/Alistamiento.vue";
import Autorizaciones from "./Formularios/Autorizaciones.vue";
import MantenimientoCorrectivo from "./Formularios/MantenimientoCorrectivo.vue";
import MantenimientoPreventivo from "./Formularios/MantenimientoPreventivo.vue";
import detallesMantenimientos from "./DetallesMantenimiento/detallesMantenimientos.vue";
import detallesMantenimientosAlistamiento from "./DetallesMantenimiento/detallesMantenimientosAlistamiento.vue";
import detallesMantenimientosAutorizaciones from "./DetallesMantenimiento/detallesMantenimientosAutorizaciones.vue";
import Swal from 'sweetalert2';

export default {
    components: {
        DataTableButtonsObjeto,
        MantenimientoPreventivo,
        MantenimientoCorrectivo,
        Alistamiento,
        Autorizaciones,
        detallesMantenimientos,
        detallesMantenimientosAlistamiento,
        detallesMantenimientosAutorizaciones
    },
    data() {
        return {
            token: null,
            tokenParametricas: null,
            loading: false,
            tipoMantenimiento: 1,
            vigiladoId: '8920005656',
            idMantenimiento: null,
            infoComplementaria: {},
            // Variables para el sistema de actualización
            itemSeleccionado: null,
            tituloOpcion: null,
            descripcionOpcion: null,

            // Prop para guardar los detalles de los mantenimientos
            detallesMantenimientos: null,

            // #region ENCABEZADOS KEYS DATATABLES
            itemsListar: null,
            headersDespacho: [
                "Tipo Mantenimiento",
                "Id Mantenimiento",
                "Placa Vehiculo",
                "Fecha Diligenciamiento",
                "Estado Mantenimiento",
            ],
            keyDespacho: [
                "tipoId",
                "id",
                "placa",
                "fechaDiligenciamiento",
                "estadoMantenimiento",
            ],

            // #endregion
        };
    },
    methods: {
        async obtenerToken() {
            try {
                const respuesta = await this.$store.dispatch("hl_post_cookie",
                    {
                        path: 'ApiSuperTransporteGenerales/TokenApiSuperTransporte'
                    }
                )
                console.log("Token obtenido", respuesta);
            } catch (error) {
                console.warn("No se ha logrado generar el token", error);
            }
        },
        async obtenerTokenParametricas() {
            try {
                const respuesta = await this.$store.dispatch("hl_post_cookie",
                    {
                        path: 'ApiSuperTransporteGenerales/TokenParametricas'
                    }
                )
                console.log("Token parámetricas obtenido", respuesta);
            } catch (error) {
                console.warn("No se ha logrado generar el token de parámetricas", error);
            }
        },
        async cambiarVista(tipoMantenimiento) {
            if (this.tipoMantenimiento === tipoMantenimiento || this.loading) return;
            this.loading = true;
            await this.obtenerValores(tipoMantenimiento);
        },
        async obtenerValores(tipoMantenimiento) {
            this.tipoMantenimiento = tipoMantenimiento
            //let consulta = this.consultarEndpoint(tipoMantenimiento)
            try {
                let response = await this.$store.dispatch('hl_get_cookie', {
                    path: `ApiSuperTransporteMantenimientos/obtener-placas/${tipoMantenimiento}/${this.vigiladoId}`
                })


                let datosAjustados = response.map(v => {
                    let nuevo = {};
                    for (let key in v) {
                        if (v[key] === null || v[key] === undefined || v[key] === '') {
                            nuevo[key] = "Sin diligenciar";
                        }
                        else {
                            nuevo[key] = v[key]
                        }
                    }

                    return nuevo;
                })
                console.log("Los datos obtenidos son:", datosAjustados);
                this.itemsListar = datosAjustados
            } catch (error) {
                console.warn("Ha ocurrido un error al obtener los valores", error);
                this.lanzarAlerta('error', 'Error', `Error al cargar los datos de ${tipoMantenimiento}`);
            }
            finally {
                this.loading = false;
            }
        },
        async confirmarMantenimiento(item) {
            if (!item.placa) {
                Swal.fire('Error', 'No se ha especificado la placa del vehículo', 'error');
                return;
            }

            console.log("Enviando datos:", item);
            try {
                this.isLoading = true;

                // Preparar los datos para el registro
                const datosRegistro = {
                    //Cambiar el vigiladoid por this.usuario.empresa.nit
                    vigiladoId: this.vigiladoId,
                    placa: item.placa,
                    tipoId: item.tipoId,
                };
                const resultado = await this.$store.dispatch('hl_post_cookie', {
                    path: 'ApiSuperTransporteMantenimientos/registrar-mantenimiento',
                    data: datosRegistro
                })

                console.log("Respuesta del servidor:", resultado);


                if (resultado.mensaje == 'Ya existe un registro inciado para esta placa, valide el listado') {
                    this.idMantenimiento = item.id
                }
                else {
                    this.obtenerValores(item.tipoId)
                    this.idMantenimiento = resultado.id
                }
                this.infoComplementaria = {
                    ...item,
                    vigiladoId: this.vigiladoId
                }

                this.$refs.Mantenimientos.show();

            } catch (error) {
                console.error("Error al registrar:", error);
                this.errorMessage = error.message || "Error desconocido";
                this.registrationStatus = 'error';

                Swal.fire({
                    icon: 'error',
                    title: 'Error al registrar',
                    text: this.errorMessage,
                    confirmButtonText: 'Aceptar'
                });
            } finally {
                this.isLoading = false;
            }
        },
        abrirModalForm() {
            this.$refs.Despacho.show();
        },


        DiferenteADespacho() {
            const opciones = {
                1: {
                    titulo: "Mantenimiento Preventivo",
                    descripcion: "Aquí se adjunta un vehículo al despacho creado, incluyendo la información técnica necesaria."
                },
                2: {
                    titulo: "Mantenimiento Correctivo",
                    descripcion: "Aquí se configura la ruta que seguirá el despacho, especificando origen, destino y detalles."
                },
                3: {
                    titulo: "Alistamiento",
                    descripcion: "Aquí se gestionan las autorizaciones necesarias para el despacho, como permisos especiales."
                },
                4: {
                    titulo: "Autorizaciones",
                    descripcion: "Aquí se registran los conductores asignados al despacho, junto con sus licencias y exámenes médicos."
                }
            };

            const opcion = opciones[this.tipoMantenimiento] || opciones["Conductores"];
            this.tituloOpcion = opcion.titulo;
            this.descripcionOpcion = opcion.descripcion;
            return "col-sm-6";

        },

        async detallesMantenimiento(item) {
            console.log(item);
            let detalles = await this.obtenerDetallesMantenimientos(item)

            if (!detalles) {
                return
            }
            else {
                this.detallesMantenimientos = detalles
                this.$refs.DetalleMantenimientos.show();
            }


        },

        //Método para obtener los detalles del mantenimiento de cualquier tipo, retornando la información del id suministado
        async obtenerDetallesMantenimientos(item) {
            try {
                if (item.estadoMantenimiento === "Iniciado") {
                    this.lanzarAlerta("warning", "Mantenimiento no reportado", "Por favor diligencia el mantenimiento para poder consultar la información.")
                    return resultado = false;
                }
                else if (item.estadoMantenimiento === "Sin reporte") {
                    this.lanzarAlerta("warning", "Mantenimiento sin diligenciar", "Por favor iniciar el diligenciamiento del mantenimiento, para consultar la información.")
                    return resultado = false;
                }

                let resultado = []
                if (this.tipoMantenimiento === 1) {
                    resultado = await this.$store.dispatch('hl_get_cookie', {
                        path: `ApiSuperTransporteMantenimientos/obtener-mantenimiento?tipo=${this.tipoMantenimiento}&idMantenimiento=${item.id}`,
                    })
                } else if (this.tipoMantenimiento === 2) {
                    resultado = await this.$store.dispatch('hl_get_cookie', {
                        path: `ApiSuperTransporteMantenimientos/obtener-mantenimiento?tipo=${this.tipoMantenimiento}&idMantenimiento=${item.id}`,
                    })
                } else if (this.tipoMantenimiento === 3) {
                    resultado = await this.$store.dispatch('hl_get_cookie', {
                        path: `ApiSuperTransporteMantenimientos/obtener-mantenimiento?tipo=${this.tipoMantenimiento}&idMantenimiento=${item.id}`,
                    })
                } else if (this.tipoMantenimiento === 4) {
                    resultado = await this.$store.dispatch('hl_get_cookie', {
                        path: `ApiSuperTransporteMantenimientos/obtener-mantenimiento?tipo=${this.tipoMantenimiento}&idMantenimiento=${item.id}`,
                    })
                } else {
                    console.warn("Tipo mantenimiento incorrecto", this.tipoMantenimiento);
                }



                return resultado
            } catch (error) {
                console.error(`Error procesando el ID ${item.id}:`, error);
            }
        },
        lanzarAlerta(tipo, titulo, texto) {
            Swal.fire({
                icon: tipo,
                title: titulo,
                text: texto,
                confirmButtonText: 'Aceptar'
            });
        },



    },
    async mounted() {
        await this.obtenerToken();
        await this.obtenerTokenParametricas();
        await this.obtenerValores(this.tipoMantenimiento)
    },
    beforeDestroy() {
        this.idMantenimiento = null,
            this.infoComplementaria = null
    }
};
</script>





<style lang="css">
.btn-evaluacion {
    border: solid 3px #16a275;
    transition: all 0.3s ease;
}

.btn-evaluacion:hover:not(:disabled) {
    border-color: #12d1df;
    transform: translateY(-2px);
}

.btn-evaluacion.active {
    border-color: #df122e;
    background-color: #df122e;
    color: white;
}

.btn-evaluacion:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.bg-button-dark {
    background-color: #10213b;
}

#inputSearch {
    width: 380px;
    max-width: 430px;
    height: 50px;
    border-radius: 30px;
    font-size: 1.2rem;
    font-weight: 700;
    transition: all 0.5s;
    border: none;
}

#inputSearch:focus {
    width: 430px;
    box-shadow: inset 0 0 0 2px rgb(242, 19, 93);
}

#inputSearch::placeholder {
    font-size: 1.2rem;
    font-weight: 700;
}

#icon-search {
    position: absolute;
    transition: 0.5s;
    top: 50%;
    transform: translate(0, -50%);
    right: 10px !important;
}
</style>
